import { SessionService } from '@absg/nim-client-shared';
import { Component } from '@angular/core';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: '[nc-failed-window]',
  templateUrl: './failed-window.component.html',
  standalone: false,
})
export class FailedWindowComponent extends AnonymousContentPage {
  constructor(public sessionService: SessionService) {
    super();
  }

  tryAgain(): void {
    this.sessionService.fireRetryDomainFetch$.next();
  }
}
